import { OfficeListVendor } from '../../../../components/Contact';

export function TBMContactOffices() {
  return <OfficeListVendor />;
}
